import axiosInstance from "./api_helper";

const deliveryService = {

    list: async ({ clientId, companyId, chantierId, commercialId, dateFrom, dateTo, sansFacture, query, regle, status, amount, accuse }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (companyId !== undefined && companyId !== null) params.companyId = companyId;
        if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (regle) params.regle = regle;
        if (query) params.query = query;
        if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
        if (status) params.status = status;
        if (accuse !== undefined && accuse !== null && Number(accuse) !== -1) params.accuse = Number(accuse);
        if (sansFacture) params.sansFacture = sansFacture;

        const response = await axiosInstance.get('/api/ventes/bon-livraison', { params });
        console.log(response)
        return response.data;
    },

    listComptoire: async ({ clientId, companyId, chantierId, commercialId, dateFrom, dateTo, sansFacture, query }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (companyId !== undefined && companyId !== null) params.companyId = companyId;
        if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;
        if (sansFacture) params.sansFacture = sansFacture;

        const response = await axiosInstance.get('/api/ventes/bon-livraison/caisse', { params });
        return response.data;
    },

    add: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison-direct', deliveryData.data);
    },
    addBL: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison/creer', deliveryData.data);
    },
    update: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/api/ventes/bon-livraison/${id}`, JSON.stringify(data));
            return response;
        } catch (error) {
            throw error;
        }
    },
    generatePdf: async (deliveryDTO) => {
        const response = await axiosInstance.post(`/api/deliveryNotes/report`, deliveryDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    delete: async (deliveryId) => {
        const response = await axiosInstance.delete(`/api/deliveryNotes/${deliveryId}`);
        return response.data;
    },
    filter: async (query) => {
        return axiosInstance.post(`/api/deliveryNotes/search`, JSON.stringify(query));
    },
    getLastSaved: async () => {
        return await axiosInstance.get(`/api/deliveryNotes/last-saved`);
    },

    annulerBLLight: async (id) => {
        return axiosInstance.delete(`/api/ventes/bon-livraison/annuler/light/${id}`);
    },
    annulerBLHard: async (id) => {
        return axiosInstance.delete(`/api/ventes/bon-livraison/annuler/hard/${id}`);
    },
    resetBL: async (id) => {
        return axiosInstance.put(`/api/ventes/bon-livraison/reset/${id}`);
    },

    findByReference: async (reference) => {
        const params = {};
        params.numero = reference;
        const response = await axiosInstance.get(`/api/ventes/bon-livraison/reference`, { params });
        return response.data;
    },
    uploadBLs: async (payload) => {
        return axiosInstance.post(`/api/ventes/bon-livraison/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getBonLivraisonsNonRegles: async (payload) => {
        const { clientId, chantierId } = payload || {};
        const q = new URLSearchParams();
        if (clientId) q.append("clientId", clientId);
        if (chantierId) q.append("chantierId", chantierId);
        return axiosInstance.get(`/api/ventes/bon-livraisons/non-regles?${q.toString()}`);
    }
}

export default deliveryService;
